<ng-container *ngIf="isPopulated">
  <div edsGrid>
    <div class="container-wide">
      <div edsRow edsFlexbox justifyContent="space-between">
        <div
          edsCol
          [columnNumbers]="{
            s: 4,
            m: 3,
            l: 'auto'
          }"
          edsSpacing="md"
        >
          <eds-section-header
            [level]="4"
            size="h4"
            [title]="data.title"
            [caveatPlacement]="data.caveatPlacement"
            [secondaryCaveatPlacement]="data.secondaryCaveatPlacement"
            [tooltip]="data.tooltip"
            [analyticsName]="data.title"
            [asOfLabel]="data.asOfLabel"
            [asOfDate]="asOfDate"
            [calculationBasis]="data.calculationBasis"
            [calculationType]="data.calculationType"
            [updateFrequency]="data.updateFrequency"
          ></eds-section-header>
        </div>
        <div
          edsCol
          [columnNumbers]="{
            s: 4,
            m: 3,
            l: 2
          }"
          edsSpacing="md"
        >
          <div *ngIf="data?.filteredAsOfDate?.length > 1">
            <eds-dropdown
              [items]="data.filteredAsOfDate"
              [label]="'products.as-of' | translate"
              (dropdownChange)="filterOnDate($event)"
            ></eds-dropdown>
          </div>
        </div>
        <div
          edsCol
          [columnNumbers]="{
            s: 4,
            m: 3,
            l: 2
          }"
          edsSpacing="md"
        >
          <button
            class="print-hidden"
            edsButton="secondary"
            (click)="triggerDownloadAction()"
          >
            {{ "products.portfolio-download-all-holdings" | translate }}
            ({{ "products.xls-file-extension" | translate }})
            <eds-icon
              type="download"
              size="small"
              edsPadding
              edsPaddingLeft="xs"
            ></eds-icon>
          </button>
        </div>
      </div>
    </div>

    <div edsRow>
      <div edsCol>
        <eds-proximal [placement]="data.proximalTop"></eds-proximal>
        <eds-proximal
          *ngIf="data.secondaryProximalTop"
          [placement]="data.secondaryProximalTop"
        ></eds-proximal>
      </div>
    </div>

    <div edsRow edsSpacing="md">
      <div edsCol>
        <eds-dynamic-table
          [colDefs]="colDefs"
          [rowData]="rowData"
          [showPagination]="true"
          [hasBorders]="true"
          [cardBreakpoint]="breakpoint"
          [labelNoMatchingData]="
            'products.portfolio-holdings-no-filter-data-message' | translate
          "
          [sortAccessibilityText]="'common.sortAccessibilityText' | translate"
          [ariaLabelGoToPage]="'common.ariaLabelGoToPage' | translate"
          [ariaLabelPagination]="'common.navigationLandmark' | translate"
          [sortAriaLiveText]="'common.sortAriaLiveText' | translate"
          [pageTransitionAriaLiveText]="
            'common.pageTransitionAriaLiveText' | translate
          "
          [labelPrevPage]="'products.previous' | translate"
          [labelNextPage]="'products.next' | translate"
        ></eds-dynamic-table>
      </div>
    </div>
  </div>

  <div edsRow>
    <div edsCol>
      <eds-proximal [placement]="data.proximalBottom"></eds-proximal>
      <eds-proximal
        *ngIf="data.secondaryProximalBottom"
        [placement]="data.secondaryProximalBottom"
      ></eds-proximal>
    </div>
  </div>
</ng-container>
